<template>
  <v-container grid-list-md text-xs-center v-if="isInvoicePaymentEnabled">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="white">
          <v-card-text class="px-0">
            <h2 class="font-weight-light pb-3">Pagamentos de Boletos e Concessionárias</h2>
            <img class="pb-5" src="@/assets/pay-per-click.png" style="max-width: 400px;" />
            <h2 v-if="partner === 'establishment'" class="font-weight-light">
              {{ staticMessage }} {{ account.fantasy_name }}!
            </h2>
            <h2 v-else class="font-weight-light">
              {{ staticMessage }} {{ partnerName }}!
            </h2>
          </v-card-text>
          <v-list three-line>
            <new-bill-payment />
            <v-divider inset></v-divider>
            <br>
            
            <!-- Seção Meus Pagamentos de Boleto integrada ao card principal -->
            <v-list-tile>
              <v-list-tile-content>
                <v-card-actions class="headline font-weight-bold pa-0">
                  <div class="headline font-weight-bold">Meus Pagamentos de Boleto</div>
                  <v-spacer></v-spacer>
                  <v-btn fab small @click="showFilters">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </v-card-actions>
                <div style="font-size: 16px; font-weight: 400; padding-top: 8px;">
                  <h3 style="font-weight: 700">
                    Subtotal: {{ $n(subtotal, "currency") }}
                  </h3>
                  <i>Utilize os Filtros para melhorar a sua busca.</i>
                </div>
              </v-list-tile-content>
            </v-list-tile>
            
            <v-divider></v-divider>
            <br>
            
            <bills-payment-table />
          </v-list>
        </v-card>
        <bills-payment-filters />
      </v-flex>
    </v-layout>
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Pagamento de Contas Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "BillPayment",
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isInvoicePaymentEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {
    // Se a rota atual termina com "/new", abrir automaticamente o formulário
    if (this.$route.path.endsWith('/new')) {
      this.$nextTick(() => {
        EventBus.$emit("show-new-bill-payment-form");
      });
    }
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      partnerName: "account/partnerName",
      isInvoicePaymentEnabled: "account/isInvoicePaymentEnabled",
      subtotal: "bills/billsPaymentSubtotal"
    }),
  },
  data() {
    return {
      staticMessage: "Realize pagamentos de boletos bancário ou concessionárias direto da sua conta digital",
    };
  },
  methods: {
    showFilters() {
      this.$store.dispatch("bills/showFilters", true);
    }
  },
  components: {
    newBillPayment: () => import("@/components/desktop/bills/NewBillPayment.vue"),
    billsPaymentTable: () => import("@/components/desktop/bills/BillsPaymentTable.vue"),
    billsPaymentFilters: () => import("@/components/desktop/bills/Filters.vue"),
  },
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>
